import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {CustomValidator} from '../../../services/custom-validator';
import {Subject} from 'rxjs';
import {Utils} from '../../../services/utils';

@Component({
  selector: 'app-service-configuration-webClient',
  templateUrl: './service-configuration-webClient.component.html',
  styleUrls: ['./service-configuration-webClient.component.css']
})
export class ServiceConfigurationWebClientComponent implements OnInit, AfterViewInit {

  @Input() modalTitle: string;
  itemSaved: Subject<boolean>;

  componentForm: FormGroup;
  objInitialState;
  config;
  pleaseWait = false;
  error;
  submitted;
  humanInteractionQueueOrderList;

  menuBackgroundColor: string;
  menuFontColor: string;
  primaryButtonBackgroundColor: string;
  primaryButtonFontColor: string;
  humanInteractionHeaderFooterBgColor: string;
  humanInteractionHeaderFooterFontColor: string;

  get formData() { return this.componentForm.controls; }

  constructor(
    private nodeConfigService: NodeConfigurationService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted = false;

    if (this.objInitialState) {
      this.config = this.objInitialState;
    }
    this.createForm();
    this.createHumanInteractionQueueOrderList();
    this.loadConfigs();
  }

  ngAfterViewInit() {
    Utils.closeColorPickerDialog('.modal-body');
  }

  private createHumanInteractionQueueOrderList() {
    this.humanInteractionQueueOrderList = [];
    this.humanInteractionQueueOrderList.push({name: 'Nenhum', value: 0});
    this.humanInteractionQueueOrderList.push({name: 'Data de criação Ascendente', value: 1});
    this.humanInteractionQueueOrderList.push({name: 'Data de criação Descendente', value: 2});
    this.humanInteractionQueueOrderList.push({name: 'Data de mudança de estado Ascendente', value: 3});
    this.humanInteractionQueueOrderList.push({name: 'Data de mudança de estado Descendente', value: 4});
    this.humanInteractionQueueOrderList.push({name: 'Tempo em fila Ascendente', value: 5});
    this.humanInteractionQueueOrderList.push({name: 'Tempo em fila Descendente', value: 6});
    this.humanInteractionQueueOrderList.push({name: 'ID da instância Ascendente', value: 7});
    this.humanInteractionQueueOrderList.push({name: 'ID da instância Descendente', value: 8});
    this.humanInteractionQueueOrderList.push({name: 'Chave de correlação Ascendente', value: 9});
    this.humanInteractionQueueOrderList.push({name: 'Chave de correlação Descendente', value: 10});
  }

  createForm() {
    this.itemSaved = new Subject();
    this.componentForm = this.formBuilder.group({
      pageSize: [ 0, [ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      batchUploadChunkSize: [ 0, [ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      humanInteractionQueueRefreshInterval: [ 0, [ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      customHumanInteractionPageSize: [ '', [ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      customHumanInteractionLabelCard: [ '', [ Validators.required ]],
      humanInteractionQueueOrder: [ '', [ Validators.required, Validators.maxLength(2000) ]],
      crivoServer: [ '', [ Validators.maxLength(2000) ]],
      crivoServerTimeout: [ 0, [ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      logoImageUrl: [ '', [ Validators.required, CustomValidator.trimRequired ]],
      collapsedMenuLogoImage: [ '', [ Validators.required, CustomValidator.trimRequired ]],
      extendedMenuLogoImage: [ '', [ Validators.required, CustomValidator.trimRequired ]],
      loginLogoImage: [ '', [ Validators.required, CustomValidator.trimRequired ]],
      headerHeight: [ 32, [ Validators.required , Validators.min(28), Validators.max(2147483647), CustomValidator.numeric]],
      pageWidth: [ 960, [ Validators.required, Validators.min(950), Validators.max(2147483647), CustomValidator.numeric  ]],
      humanInteractionLayoutStyle: [ 1 ]
    });
  }

  loadConfigs() {
    this.error = '';
    this.nodeConfigService.getByNode(this.config.machineId, this.config.hostName, 3)
      .subscribe(result => {
        if (result) {
          this.componentForm.patchValue({
            pageSize:  result.pageSize,
            humanInteractionQueueOrder:  result.humanInteractionQueueOrder,
            graphicMaxWidthStateName:  result.graphicMaxWidthStateName,
            crivoServer:  result.crivoServer,
            crivoServerTimeout:  result.crivoServerTimeout,
            humanInteractionQueueRefreshInterval:  result.humanInteractionQueueRefreshInterval,
            batchUploadChunkSize:  result.batchUploadChunkSize,
            customHumanInteractionPageSize:  result.customHumanInteractionPageSize,
            customHumanInteractionLabelCard:  result.customHumanInteractionLabelCard === '1',
            logoImageUrl: result.logoImageUrl,
            collapsedMenuLogoImage: result.collapsedMenuLogoImage,
            extendedMenuLogoImage: result.extendedMenuLogoImage,
            loginLogoImage: result.loginLogoImage,
            headerHeight: result.headerHeight,
            pageWidth: result.pageWidth,
            humanInteractionLayoutStyle: result.humanInteractionLayoutStyle
          });
          this.humanInteractionHeaderFooterBgColor = result.headerBackgroundColor;
          this.humanInteractionHeaderFooterFontColor = result.headerFontColor;
          this.menuBackgroundColor = result.menuBackgroundColor;
          this.menuFontColor = result.menuFontColor;
          this.primaryButtonFontColor = result.buttonFontColor;
          this.primaryButtonBackgroundColor = result.buttonBackgroundColor;
          this.pleaseWait = false;

        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  restoreDefaultSettings() {
    this.error = '';
    this.nodeConfigService.getWebClientDefaultSettings()
      .subscribe( result => {
        if (result) {
          this.componentForm.patchValue({
            batchUploadChunkSize:  result.batchUploadChunkSize,
            logoImageUrl: result.logoImageUrl,
            collapsedMenuLogoImage: result.collapsedMenuLogoImage,
            extendedMenuLogoImage: result.extendedMenuLogoImage,
            loginLogoImage: result.loginLogoImage,
            headerHeight: result.headerHeight,
            pageWidth: result.pageWidth,
          });
          this.humanInteractionHeaderFooterBgColor = result.headerBackgroundColor;
          this.humanInteractionHeaderFooterFontColor = result.headerFontColor;
          this.menuBackgroundColor = result.menuBackgroundColor;
          this.menuFontColor = result.menuFontColor;
          this.primaryButtonFontColor = result.buttonFontColor;
          this.primaryButtonBackgroundColor = result.buttonBackgroundColor;
        }
      }, error1 => {
        this.error = error1;
      });
  }

  onClose() {
    this.bsModalRef.hide();
    this.itemSaved.next(false);
  }

  onSave() {
    this.error = '';
    this.pleaseWait = true;
    const obj = this.componentForm.getRawValue();
    obj.machineId = this.config.machineId;
    obj.hostName = this.config.hostName;
    obj.headerBackgroundColor = this.humanInteractionHeaderFooterBgColor;
    obj.headerFontColor = this.humanInteractionHeaderFooterFontColor;
    obj.menuBackgroundColor = this.menuBackgroundColor;
    obj.menuFontColor = this.menuFontColor;
    obj.buttonFontColor = this.primaryButtonFontColor;
    obj.buttonBackgroundColor = this.primaryButtonBackgroundColor;
    if (obj.customHumanInteractionLabelCard) {
      obj.customHumanInteractionLabelCard = '1';
    } else {
      obj.customHumanInteractionLabelCard = '0';
    }
    this.nodeConfigService.updateWebClient(obj).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        this.itemSaved.next(true);
        setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

  trimSpaces(element, formControlName) {
    const elValue = element.target.value;
    if (elValue !== '') {
      this.componentForm.get(formControlName).setValue(elValue.trim());
    }
  }
}
